import { debounce } from "lodash";
import { useEffect, useMemo, useRef } from "react";

/** Chama o callback, não mais de uma vez, após o delay especificado
 *
 *
 * usage: const functionCall = useDebounce(() => { console.log("hello") }, 500);
 *
 * functioncall(); // hello
 *
 * Pode chamar functionCall quantas vezes quiser, mas só vai executar o callback uma vez, depois de 500ms
 */
export const useDebounce = (callback: any, delay: number, params?: any[]) => {
	const callbackRef: any = useRef();
	const paramsRef: any = useRef<any[]>();

	useEffect(() => {
		callbackRef.current = callback;
	}, [callback]);

	useEffect(() => {
		paramsRef.current = params;
	}, [params]);

	const debouncedCallback = useMemo(() => {
		const func = () => {
			if (paramsRef.current) {
				if (callbackRef.current)
					callbackRef.current(...paramsRef.current);
			} else {
				if (callbackRef.current) callbackRef.current();
			}
		};

		return debounce(func, delay);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return debouncedCallback;
};
